var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.165 19.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #04be76;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-edit",
    transform: "translate(-0.416 -0.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-edit-2",
    "data-name": "icon-edit",
    className: "cls-1",
    d: "M16.408,19.166H1.168A1.17,1.17,0,0,1,0,18V2.759A1.153,1.153,0,0,1,1.168,1.6H11.182l-1.6,1.6H2.126a.528.528,0,0,0-.529.5V17.069a.521.521,0,0,0,.489.5l13.428.005a.492.492,0,0,0,.461-.5V9.582l1.6-1.6V18A1.167,1.167,0,0,1,16.408,19.166ZM4.8,14.375h0l.7-3.2,8.586-8.86L16.8,5.036,7.987,13.671l-3.192.7ZM17.32,4.616h0L14.55,1.846,16.138.258A.877.877,0,0,1,16.762,0a.892.892,0,0,1,.629.258l1.517,1.517a.9.9,0,0,1,0,1.258L17.32,4.615Z",
    transform: "translate(0.416 0.417)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.28f28c302b04e3798d143477e1265ff1.svg";
export { ForwardRef as ReactComponent };